import React, { useState } from 'react'
import {
  Container,
  Typography,
  Box,
  Paper,
  Tabs,
  Tab,
} from '@mui/material'
import { useGetReportsQuery, useGetTemplatesQuery } from '@/core/services/report'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { t, Trans } from '@lingui/macro'
import { skipToken } from '@reduxjs/toolkit/query'
import { ReportsTabContent } from './components/ReportsTabContent'
import { TemplatesTabContent } from './components/TemplatesTabContent'


export default function ReportsPage() {
  const authUser = useAppSelector(selectAuthUser)
  const [tabValue, setTabValue] = useState<number>(0)
  const { data: templates, isLoading: isLoadingTemplates, error: templatesError } = useGetTemplatesQuery(
    authUser?._id ? { userId: authUser._id } : skipToken,
    { refetchOnMountOrArgChange: true }
  )

  const { data: reports, isLoading: isLoadingReports, error: reportsError } = useGetReportsQuery(
    authUser?._id ? { userId: authUser._id } : skipToken,
    { refetchOnMountOrArgChange: true }
  )

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          <Trans> Report management</Trans>
        </Typography>

        <Paper sx={{ mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
            <Tab label={t`Reports`} />
            <Tab label={t`Report templates`} />
          </Tabs>
        </Paper>

        {tabValue === 0 && (
          <ReportsTabContent isLoading={isLoadingReports} error={reportsError} reports={reports} />
        )}

        {tabValue === 1 && (
          <TemplatesTabContent isLoading={isLoadingTemplates} error={templatesError} templates={templates} />
        )}
      </Box>
    </Container>
  )
}
